import ColumnCrudTableType from "../../../componentes/CRUD/columnCrudTableType";
import moment from "moment";

export const variablesDashBoard: {
  empresa: string | null;
  de: Date | null;
  ate: Date | null;
  registro: string;
} = {
  empresa: null,
  de: moment()
    .add(-1, "day")
    .toDate(),
  ate: moment().toDate(),
  registro: "VENDA",
};

export const variablesDashBoardExibicao: {
  empresa: string | null;
  de: Date | null;
  ate: Date | null;
  registro: string;
} = {
  empresa: null,
  de: moment()
    .add(-1, "day")
    .toDate(),
  ate: moment().toDate(),
  registro: "Venda",
};

export const mapVariablesDashBoard = {
  empresa: "Conciliador",
  de: "Venda de",
  ate: "Venda até",
  registro: "Registros de",
};

type FiltroRadar = typeof variablesDashBoard;

const escapaHtml = (texto: string) =>
  texto.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

export const descricaoFiltroRadar = (variaveis: FiltroRadar, exibicao: FiltroRadar) => {
  const tipo = variaveis.registro === "PAGAMENTO" ? "Pagamento" : "Venda";
  const itens = [
    `Conciliador: ${variaveis.empresa && exibicao.empresa ? escapaHtml(exibicao.empresa) : "Todos"}`,
    `Registros de: ${tipo}`,
  ];
  if (variaveis.de) {
    itens.push(`${tipo} de: ${moment(variaveis.de).format("DD/MM/YYYY")}`);
  }
  if (variaveis.ate) {
    itens.push(`${tipo} até: ${moment(variaveis.ate).format("DD/MM/YYYY")}`);
  }
  return `<b>Filtro:</b> ${itens.join(" | ")}`;
};

export const copiaFiltroRadar = (variaveis: FiltroRadar, exibicao: FiltroRadar) => ({
  variaveis: { ...variaveis },
  exibicao: { ...exibicao },
});

export const restauraFiltroRadar = (
  copia: ReturnType<typeof copiaFiltroRadar>,
  variaveis: FiltroRadar,
  exibicao: FiltroRadar
) => {
  Object.assign(variaveis, copia.variaveis);
  Object.assign(exibicao, copia.exibicao);
};

export const colunasDashBoard: Array<ColumnCrudTableType> = [];

export const actionsDashBoard = [];
